module.exports = "<footer>\n  <p>Version 1.1.8 2020 &#169; Block Voucher Admin Dashboard</p>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/common/footer/footer.component.html
// module id = ../../../../../src/app/components/common/footer/footer.component.html
// module chunks = main